import { Box, Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { useContext } from 'react'
import ApplicationContext from '@platform/react/context/application'
import { getThemeColor } from 'lib/util'
import StatusChip from 'ui/Element/Text/StatusChip'

/**
 * Intended to display the status of the ticket.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
export const ListItemCellTicketStatus = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)
  const {
    status: statusKey,
    statusReason: statusReasonKey,
    modify: { timestamp: modifyTimestamp = '' },
    events,
  } = props
  const [statusReason] = events?.getStatusReason?.(statusReasonKey || -1) || []
  const statusReasonLabel = statusReason?.value
  const modifyDate = modifyTimestamp
    ? intl.getLocaleDate(modifyTimestamp, { dateStyle: 'short' })
    : ''

  return (
    <>
      <StatusChip
        value={statusKey}
        events={{ onOpen: events?.getStatus }}
        textVariant={'12/bold'}
        shape={'rounded'}
        size={'tiny'}
      />
      <Typography
        variant={'caption'}
        color={'textSecondary'}
        className={classes.row}
      >
        {!statusReasonLabel ? null : (
          <>
            <Box
              component={'span'}
              sx={{
                fontWeight: 'bold',
                color: theme => getThemeColor(theme, statusReason.color),
              }}
            >
              {statusReason?.value}
            </Box>
            &nbsp;-&nbsp;
          </>
        )}
        { modifyDate }
      </Typography>
    </>
  )
}

export default CellHOC(ListItemCellTicketStatus)
